import { storyParagraphs, storyHighlights } from "@/mocks/home";

export default function StorySection() {
  return (
    <section id="story" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-xs font-label tracking-[0.2em] text-accent-600">故事简介 / STORY</span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950">
              废柴纲与他的家庭教师
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            一个自称杀手的婴儿闯入平凡中学生家里，从此改写了他的人生轨迹。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8">
          <div className="reveal lg:col-span-3 space-y-4">
            {storyParagraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base leading-loose text-foreground-700">
                {p}
              </p>
            ))}

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-3">
              {storyHighlights.map((h) => (
                <div
                  key={h.title}
                  className="rounded-lg bg-background-50 border border-background-200 px-4 py-4"
                >
                  <div className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${h.icon} text-xl`} />
                  </div>
                  <h3 className="mt-3 text-sm font-label text-foreground-900">{h.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{h.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal lg:col-span-2 flex flex-col gap-4">
            <div className="w-full h-[260px] md:h-[320px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=stack%20of%20colorful%20manga%20comic%20volumes%20arranged%20on%20a%20wooden%20desk%20beside%20a%20warm%20desk%20lamp%2C%20cozy%20evening%20light%2C%20soft%20orange%20tones%2C%20editorial%20still%20life%20photography%2C%20shallow%20depth%20of%20field%2C%20clean%20neutral%20background&width=1000&height=1200&seq=story-manga-stack-2026&orientation=portrait"
                alt="木质桌面上整齐摆放的漫画单行本与暖色台灯"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg bg-secondary-50 border border-secondary-200 px-5 py-5">
              <h3 className="font-label text-sm text-secondary-900 flex items-center gap-2">
                <i className="ri-lightbulb-line" />
                为什么值得一看
              </h3>
              <ul className="mt-3 space-y-2.5">
                <li className="flex gap-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-check-line text-secondary-600 mt-0.5" />
                  前期笑点密集、后期燃点十足，情绪起伏非常完整。
                </li>
                <li className="flex gap-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-check-line text-secondary-600 mt-0.5" />
                  西装黑手党造型与死气之炎属性设定，辨识度极高。
                </li>
                <li className="flex gap-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-check-line text-secondary-600 mt-0.5" />
                  群像塑造扎实，反派与友方都有各自的高光时刻。
                </li>
                <li className="flex gap-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-check-line text-secondary-600 mt-0.5" />
                  配乐与OP、ED被许多观众奉为经典，越听越上头。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}